import * as React from 'react';
import { IPeopleProps, IPeopleState } from './IPeople';
import PersonComponent from '../PersonComponent/PersonComponent';
import IPersonComponent from '../PersonComponent/IPersonComponent';
import Loader from '@appComponents/Loader/Loader';
import Search from '../InvestorSearch/InvestorSearch';
import { animateScrollTo, deepCopy } from '@features/utils/functions';
import EmptySVG from '../../icons/noinvestors.svg';

const isEqual = require('lodash.isequal');

import * as styles from './PeopleStyles.module.scss';
import * as appStyle from '../../AppStyle.module.scss';

class People extends React.Component<IPeopleProps, IPeopleState> {

  constructor(props: IPeopleProps) {
    super(props);

    this.state = {
      data: this.props.people || {},
      loader: this.props.people === null ? true : false,
      letterHelper: this.props.title === 'Investor' ? 'i' : 't',
      allVisible: false,
    };

    this.addInvestorHandler = this.addInvestorHandler.bind(this);
    this.removePersonHandler = this.removePersonHandler.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps: IPeopleProps) {

    if (!isEqual(nextProps.people, this.props.people)) {
      this.setState({
        data: {
          ...nextProps.people,
        },
      }, () => {
        if (this.props.updateStateFromChild) this.props.updateStateFromChild(this.state.data);
      });
    }
    this.setState({
      loader: false,
    });
  }

  updateStateFromChild = (index: string, data: object) => {
    const _data = deepCopy(this.state.data);
    _data[index] = { ..._data[index], ...data };
    this.setState({
      data: _data,
    }, () => {
      if (this.props.updateStateFromChild) this.props.updateStateFromChild(this.state.data);
    });
  }

  componentDidUpdate(prevProps: IPeopleProps, prevState: IPeopleState) {
    if (Object.keys(prevState.data).length > Object.keys(this.state.data).length && this.props.updateStateFromChild) {
      this.props.updateStateFromChild(this.state.data);
    }
  }

  removePersonHandler = (index: string) => {
    const _data = deepCopy(this.state.data);
    if (!_data[index].id) {
      delete _data[index];
    } else _data[index]._destroy = 1;
    this.setState({
      data: _data,
    }, () => {
      if (this.props.updateStateFromChild) this.props.updateStateFromChild(this.state.data);
    });
  }

  peopleList() {
    const peopleList = this.state.data;
    const { allVisible } = this.state;
    const dataKeys = (peopleList !== undefined) ? Object.keys(peopleList) : [];
    const notDisplay = Object.values(peopleList).every((elem: any) => {
      return elem._destroy !== undefined;
    });
    let result: any = <div className={styles.empty}><EmptySVG /><p>No {this.props.title}s</p></div>;

    const getKey: any = (personId: number, index: string, isNew: boolean, type: string) => {
      if (personId && isNew) {
        const duplicate = !Object.values(peopleList).every((elem: any) => {
          if (elem.id !== personId)  return true;

          return false;
        });

        if (duplicate) return personId + index;

        return personId;
      }

      if (personId) return type ? personId + type : personId;

      return index;
    };

    if (this.state.loader) {
      result = <Loader />;
    } else if (dataKeys.length > 0 && !notDisplay) {
      const tmpList = allVisible ? dataKeys : dataKeys.slice(0,6);
      result = tmpList.map((index: string) => {
        const person: IPersonComponent = peopleList[index];

        return !person._destroy ? (
          <PersonComponent
            key={getKey(person.id, index, person.newSearchInvestor, person.type)}
            index={index}
            editMode={this.props.editMode}
            avatar={person.avatar}
            name={person.name}
            role={person.role}
            linkedin_page={person.linkedin_page}
            removePerson={this.removePersonHandler}
            dispatch={this.props.dispatch}
            updateStateFromChild={this.updateStateFromChild}
            id={this.state.letterHelper + index}
            editable={person.editable !== undefined ? person.editable : true}
            isInvestor={this.props.title === 'Investor'}
          />
        ) : null;
      });
    }

    return result;
  }

  addInvestorHandler(investor: any = null) {
    const objectKeys = Object.keys(this.state.data);
    const oKL = objectKeys.length;
    const objectIndex = Number(objectKeys[oKL - 1]) !== oKL ? oKL : oKL + 1;

    let objectData: any = { avatar: null, name: '', role: '', linkedin_page: '', editable: true };

    if (investor.id) {
      const isAdded = !Object.values(this.state.data).every((inv: any) => {
        if (!inv.newSearchInvestor) return true;
        if (inv.newSearchInvestor && inv._destroy) return true;
        if (inv.id === investor.id) return false;
        return true;
      });

      if (isAdded) return;

      objectData = { id: investor.id,
        avatar: null, name: investor.name, role: '', linkedin_page: '', editable: false, newSearchInvestor: true };
    }

    const data = Object.assign({
      [objectIndex]: objectData,
    }, this.state.data);
    this.setState({
      data,
    }, () => {
      setTimeout(() => {
        if (investor) {
          if (this.props.updateStateFromChild) this.props.updateStateFromChild(this.state.data);
        }
        const element = document.getElementById(`${this.state.letterHelper}${objectIndex}`);
        if (element) animateScrollTo(null, element, 50);
      }, 0);
    });
  }

  addInvestor() {
    return (
      <button className={appStyle.addButton} onClick={this.addInvestorHandler}>Add {this.props.title}</button>
    );
  }

  render() {
    const id = this.props.title === 'Investor' ? 'investors' : 'team-members';
    const peopleCount = Object.keys(this.state.data).length;
    const { allVisible } = this.state;
    return (
      <div className={styles.investors} id={id}>
        <h2>{this.props.title}s <span>{this.countPeople()}</span></h2>
        {this.props.editMode && this.addInvestor()}
        {this.props.editMode && id === 'investors' &&
          <Search companyId={this.props.companyID} btnCallback={this.addInvestorHandler} />
        }
        <div className={styles.investorsList}>
          {this.peopleList()}
        </div>
        { peopleCount >= 7 &&
          <div className={styles.showAllContainer}>
            <button
              className={styles.showAll}
              onClick={() => {this.toggleShowAllPeople();}}
            >
              {
               allVisible ?
               `Hide (${peopleCount - 6}) ${this.props.title}${peopleCount >= 8 ? 's' : '' }`
               :
               `Show All (${peopleCount - 6} more)`
              }
            </button>
          </div>
        }
      </div>
    );
  }

  private countPeople() {
    const tmp = Object.values(this.state.data).filter((value:IPersonComponent) => {
      return value._destroy !== 1;
    });
    return this.props.title === 'Investor' ? tmp.length : Object.keys(this.state.data).length;
  }

  private toggleShowAllPeople() {
    this.setState({ allVisible:!this.state.allVisible });
  }
}

export default People;
